import Hero from "@/components/Hero";
import Categories from "@/components/Categories";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import kevin8 from "@/assets/kevin_8.jpg";
import kevin4 from "@/assets/kevin_4.webp";
import SEO from "@/components/SEO";
import FeaturedPosts from "@/components/FeaturedPosts";

const Index = () => {
  const { t } = useLanguage();

  return (
    <main
      id="main-content"
      className="min-h-screen"
    >
      {/* SEO: Added Heilbronn keywords for local OD searches [Google guideline] */}
      <SEO
        title={t("seo.home.title")}
        description={t("seo.home.description")}
        keywords={t("seo.home.keywords").split(",").map((k) => k.trim())}
      />
      <Hero />

      <div
        className="w-full h-[80vh] overflow-hidden"
        style={{
          clipPath: "polygon(0 10vw, 100% 0, 100% calc(100% - 10vw), 0 100%)"
        }}
      >
        {/* SEO: Converted to img tag for better indexation and performance.
            Restored parallax effect on desktop using fixed positioning. */}
        <img
          src={kevin8}
          alt={t("home.image.kevin8.alt")}
          className="w-full h-full object-cover md:fixed md:inset-0 md:-z-10"
          // SEO: Prioritize LCP image loading
          loading="eager"
          fetchPriority="high"
        />
      </div>

      <Categories />

      {/* About Me Trigger Section */}
      <section className="py-12 px-4 sm:px-6 relative overflow-hidden">
        <div className="container mx-auto text-center px-4 sm:px-6">
          <div className="max-w-3xl mx-auto space-y-6 sm:space-y-8 animate-fade-in">
            <h2 className="text-4xl md:text-5xl font-bold">
              {t("about.heading")}
            </h2>
            <p className="text-xl text-muted-foreground">
              {t("about.description")}
            </p>
            <Link
              to="/about"
              className="group inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
            >
              {t("about.cta")}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      <div
        className="w-full h-[80vh] overflow-hidden"
        style={{
          clipPath: "polygon(0 10vw, 100% 0, 100% calc(100% - 10vw), 0 100%)"
        }}
      >
        {/* SEO: Converted to img tag for better indexation and performance.
            Restored parallax effect on desktop using fixed positioning. */}
        <img
          src={kevin4}
          alt={t("home.image.kevin4.alt")}
          className="w-full h-full object-cover md:fixed md:inset-0 md:-z-10"
          loading="lazy"
        />
      </div>

      <FeaturedPosts />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
